export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.22-1304.47",
  commitId: "3d7847c01a20847a283e62219c836c1239d32bac",
  commitTime: "2026-07-22T13:04:47.000Z",
});
